//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ElementsSeguroCombinadaTooltip',
  props: {
    visible: { type: Boolean, default: false },
    description: {
      type: String,
      default: 'Si tu combinada pierde por una sola selección, recibirás una freebet.'
    }
  },
  computed: {
    config() {
      return this.$store.getters.seguroCombinadaConfig
    },
    hasValidConfig() {
      return !!(
          this.config &&
          this.config.minimum_selection_per_bet &&
          this.config.minimum_odds_per_selection
      )
    },
    requirements() {
      const req = []
      if (this.config.minimum_selection_per_bet) {
        req.push(`${this.config.minimum_selection_per_bet} ${this.$t('selecciones como mínimo')}`)
      }
      if (this.config.minimum_odds_per_selection) {
        req.push(
            `${this.$t('Cuota mínima por selección')}: ${parseFloat(this.config.minimum_odds_per_selection).toFixed(2)}`
        )
      }
      const prizes = this.$store.getters.seguroCombinadaPrizes
      const maxMaxValue = prizes.length
          ? Math.max(...prizes.map(item => item.max_value))
          : 25;

      req.push(`${this.$t('Importe máximo de la freebet: ')}: ${parseFloat(maxMaxValue).toFixed(0)}€`)

      return req
    }
  }
}
